(function () {
  function setLoading(container, isLoading) {
    var submitButton = container.querySelector('[data-card-bis-submit]');
    var spinner = submitButton.querySelector('.loading__spinner');
    submitButton.disabled = isLoading;
    submitButton.classList.toggle('loading', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function showState(container, state) {
    var form = container.querySelector('[data-card-bis-form]');
    var success = container.querySelector('[data-card-bis-success]');
    var error = container.querySelector('[data-card-bis-error]');
    form.classList.add('hidden');
    success.classList.add('hidden');
    error.classList.add('hidden');
    if (state === 'success') success.classList.remove('hidden');
    if (state === 'error') error.classList.remove('hidden');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-card-bis-trigger]');
    if (!trigger) return;
    var container = trigger.closest('[data-card-bis]');
    if (!container) return;
    trigger.classList.add('hidden');
    container.querySelector('[data-card-bis-form]').classList.remove('hidden');
    container.querySelector('[data-card-bis-email]').focus();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-card-bis-form]');
    if (!form) return;
    event.preventDefault();

    var container = form.closest('[data-card-bis]');
    var variantId = container.getAttribute('data-variant-id');
    var email = container.querySelector('[data-card-bis-email]').value;

    setLoading(container, true);

    window.KlaviyoBisApi.subscribe(variantId, email)
      .then(function () {
        setLoading(container, false);
        showState(container, 'success');
      })
      .catch(function (error) {
        setLoading(container, false);
        console.error(error);
        showState(container, 'error');
      });
  });
})();
